import Axios, { AxiosInstance } from 'axios';

import { store } from '../../store';
import { AuthActions } from '../../store/entities/auth/auth.actions';

const baseURL = process.env.REACT_APP_API_URL!;
const reportsDownloadUrl = process.env.REACT_APP_DOWNLOAD_REPORT_API!;
class Api {
  axios: AxiosInstance;
  constructor() {
    this.axios = Axios.create({
      baseURL,
      timeout: 1 * 60 * 1000,
    });

    this.axios.interceptors.response.use(
      function (response: any) {
        return response;
      },
      (error: any) => {
        // Auto logout when status code is 401
        if (error?.response?.status === 401) {
          return store?.dispatch((AuthActions as any).logoutUser());
        }

        return Promise.reject(error);
      }
    );
  }

  private apiLogic = async (method: string, url: string, data: any = {}) => {
    const { token } = store?.getState()?.auth;

    if (method === 'get' || method === 'delete') {
      return await (this.axios as any)[method](url, {
        params: data.params ?? {},
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          ...data?.headers,
        },
      });
    }

    return await (this.axios as any)[method](
      url,
      data.body ? data.body : data,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          ...data?.headers,
        },
      }
    );
  };

  get = async (url: string, data: any = {}) => {
    return await this.apiLogic('get', url, data);
  };

  post = async (url: string, data: any) => {
    return await this.apiLogic('post', url, data);
  };

  put = async (url: string, data: any) => {
    return await this.apiLogic('put', url, data);
  };

  patch = async (url: string, data: any) => {
    return await this.apiLogic('patch', url, data);
  };

  deleteApi = async (url: string, data: any = {}) => {
    return await this.apiLogic('delete', url, data);
  };

  fetchBase = async (baseDomain: string, url: string) => {
    const { token } = store?.getState()?.auth;

    return await fetch(`${baseDomain}/${url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  };

  fetch = async (url: string) => {
    const response = await this.fetchBase(baseURL, url);
    return response;
  };

  fetchReports = async (url: string) => {
    const response = await this.fetchBase(reportsDownloadUrl, url);
    return response;
  };

  convertToFormDataHelper = (data: any, formData: FormData) => {
    const append = (key: string, val: any) => {
      if (val == null) return;
      if (val instanceof File || val instanceof Blob)
        return formData.append(key, val);
      if (val instanceof Date) return formData.append(key, val.toISOString());
      const t = typeof val;
      if (t !== 'object') return formData.append(key, String(val));
      if (Array.isArray(val)) {
        val.forEach((item, i) => append(`${key}[${i}]`, item));
        return;
      }
      Object.keys(val).forEach((k) => append(`${key}[${k}]`, val[k]));
    };

    Object.keys(data).forEach((key) => {
      append(key, data[key]);
    });
    return formData;
  };

  convertToFormData = (data: any) => {
    if (data == null) return null;
    return this.convertToFormDataHelper(data, new FormData());
  };
}

export const ApiService = new Api();
